import React from 'react';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55 } },
};

const Contact = () => (
  <section id="contact" className="section contact-section">
    <div className="section-inner">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-80px' }}
        variants={{ visible: { transition: { staggerChildren: 0.12 } } }}
      >
        <motion.p className="section-label" variants={fadeUp}>Contact</motion.p>
        <motion.h2 className="section-title" variants={fadeUp}>Get In Touch</motion.h2>

        <motion.div className="contact-grid" variants={fadeUp}>
          <div>
            <p className="contact-intro">
              Have a project in mind, want to collaborate, or just want to say hello?
              My inbox is always open.
            </p>

            <a href="tel:+917506524707" className="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
              </svg>
              +91 7506524707
            </a>

            <a href="mailto:harshsinghzero@gmail.com" className="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              harshsinghzero@gmail.com
            </a>

            <a href="https://linkedin.com/in/harshxdev" target="_blank" rel="noopener noreferrer" className="contact-item">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
              LinkedIn Profile
            </a>

            <a href="https://form.jotform.com/242852385177465" target="_blank" rel="noopener noreferrer" className="contact-work-btn">
              WORK TOGETHER
            </a>
          </div>

          <div className="contact-form-side">
            <div className="contact-form-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <p className="contact-form-title">Let's build something great</p>
            <p className="contact-form-text">
              Open to full-time roles, freelance projects, and interesting collaborations.
              Response time is usually within 24 hours.
            </p>
            <a href="mailto:harshsinghzero@gmail.com" className="btn-primary">
              Send a Message
            </a>
          </div>
        </motion.div>
      </motion.div>
    </div>
  </section>
);

export default Contact;
